import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** single person. Decorative line icon; always pair with a visible text label. */
export function UserIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <circle cx="12" cy="8" r="3.8" />
      <path d="M5 20.5a7 7 0 0 1 14 0" />
    </IconSvg>
  )
}
